import IdService from 'id-service'
/*

End Goal:
- Merge Fems-Service and Modal-Wrapper into single component, such that:

<fems :femsName="" :femsVersion="" :aEvents="" :dataset="" :form="modal||component"></fems>
<fems femsName="advertiserList" femsVersion="asdf" aEvents="[{},{}]" dataset="{a:1}" form="component"></fems>

Possible partial step - create a FEMS-wrapper in the patter of Modal-wrapper:
<modal-wrapper :femsName :femsVersion :aEvents :dataset></modal-wrapper>
<fems-wrapper :femsName :femsVersion :aEvents :dataset></fems-wrapper>
*/

// Bootstrap FEMS initialisation bundle and invoke initialisation
function renderChildFems(femsName, femsVersion, idName) {
  // create correct format of fems name for rendering (e.g. advertiser_edit_v2)
  const _femsNameAndVersion = `${femsName.replace(/-/g, "_")}_${femsVersion}`

  // Don't reload bundle if invocation function already available - just invoke
  if (
    window.adacado_render_functions &&
    window.adacado_render_functions[_femsNameAndVersion] &&
    typeof window.adacado_render_functions[_femsNameAndVersion] == "function"
  ) {
    window.adacado_render_functions[_femsNameAndVersion](
      `${idName || femsName}`
    )
  } else {
    const script = document.createElement("script")
    script.src = `/${femsName}/${femsVersion}/comp`
    script.onload = () => {
      // Call the FE Microservice render function that was attached to Window
      if (
        window.adacado_render_functions &&
        window.adacado_render_functions[_femsNameAndVersion]
      ) {
        // render specific page
        window.adacado_render_functions[_femsNameAndVersion](
          `${idName || femsName}`
        )
      }
    }
    document.head.appendChild(script)
  }
}

function teardownChildFems(femsName, femsVersion, idName) {
  // create correct format of fems name for rendering (e.g. advertiser_edit_v2)
  const _femsNameAndVersion = `${femsName.replace(/-/g, "_")}_${femsVersion}_${idName||femsName}`

  if (
    window.adacado_teardown_functions &&
    window.adacado_teardown_functions[_femsNameAndVersion] &&
    typeof window.adacado_teardown_functions[_femsNameAndVersion] == "function"
  ) {
    window.adacado_teardown_functions[_femsNameAndVersion]()
  }
}

/*
  Instance Hooks are pre-set callbacks that may have been set by a parent FEMS to be called
  by this (child) FEMS if present, ie a callback when this FEMS is loaded.  Instance Hooks should be
  attached to global namespaced adacado object such that they reflect the Vue 2 lifecycle hooks
  See https://vuejs.org/v2/guide/instance.html

  window.adacado.instanceHooks = {
    [instanceId]: {
      beforeCreate: [functions],
      created: [functions],
      beforeMount: [functions],
      mounted: [functions],
      beforeUpdate: [functions],
      updated: [functions],
      beforeDestroy: [functions],
      destroyed: [functions],
    }
  }
*/

// a function to add a specific hook given instanceId, hookType, function (subscribe)
// ie this.FemsService.addInstanceHook(this.instanceId, 'mounted', namedFunction)
function addInstanceHook(instanceId, hook, functionName) {
  window.adacado = window.adacado || {}
  window.adacado.instanceHooks = window.adacado.instanceHooks || {}
  window.adacado.instanceHooks[instanceId] = window.adacado.instanceHooks[instanceId] || {}

  if (window.adacado.instanceHooks[instanceId][hook]) {
    window.adacado.instanceHooks[instanceId][hook].push(functionName)
  } else {
    window.adacado.instanceHooks[instanceId][hook] = [functionName]
  }
}

// a function to remove a specific hook given instanceId, hookType, function (unsubscribe)
function removeInstanceHook(instanceId, hook, functionName) {
  if (window.adacado &&
      window.adacado.instanceHooks &&
      window.adacado.instanceHooks[instanceId] &&
      window.adacado.instanceHooks[instanceId][hook] &&
      window.adacado.instanceHooks[instanceId][hook].indexOf(functionName) > -1
  ) {
    const indexToDelete = window.adacado.instanceHooks[instanceId][hook].indexOf(functionName)
    window.adacado.instanceHooks[instanceId][hook].splice(indexToDelete, 1)
  }
}

// a function to remove all hooks of an instanceId (unsubscribe all)
// ie, this.FemsService.removeAllHooks(this.instanceId)
function removeAllHooks(instanceId) {
  if (window.adacado &&
      window.adacado.instanceHooks &&
      window.adacado.instanceHooks[instanceId]
    )
    delete window.adacado.instanceHooks[instanceId]
}

// a function to generate instance id given femsName, femsVersion
// return: instance id e.g. image-source-selectorv1adb3af5442340
function generateInstanceId(femsName, femsVersion) {
  return `${femsName}${femsVersion}${IdService.generate()}`
}

export default {
  renderChildFems,
  teardownChildFems,
  addInstanceHook,
  removeInstanceHook,
  removeAllHooks,
  generateInstanceId
}
